<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="deviceId" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="物联网IMEI卡号" v-model="imei" clearable></el-input>
      </el-col>
    
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="data"
      border
      row-key="id"
      stripe
      style="width: 100%"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="device_id" label="设备编号" width="160">
      </el-table-column>
      <el-table-column prop="imei" label="IMEI" width="180"> </el-table-column>
      <el-table-column prop="dayTime" label="日期时间" width="180">
      </el-table-column>
      <el-table-column prop="protocolVer" label="protocol_ver" width="120"> </el-table-column>
      <el-table-column prop="swVer" label="sw_ver" width="120"> </el-table-column>
      <el-table-column prop="hwVer" label="hw_ver" width="120"> </el-table-column>
      <el-table-column prop="iccid" label="iccid" width="200"> </el-table-column>
      <el-table-column prop="imsi" label="imsi" width="150"> </el-table-column>
      <el-table-column prop="mac" label="mac" width="150"> </el-table-column>
    </el-table>

    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>
  
  <script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      deviceId: "",
      imei: "",
      imsi: "",
      data: [],
      linkList: [
        { label: "查看历史数据", path: "/equipment/internationalGPS/equi/lishi/" },
        { label: "上传车辆状态", path: "/equipment/internationalGPS/equi/zhuangtai/" },
        { label: "上传设备登陆信息", path: "/equipment/internationalGPS/equi/longin/" },
        { label: "上传配置参数信息", path: "/equipment/internationalGPS/equi/peizhi/" },
        { label: "上传设备日志", path: "/equipment/internationalGPS/equi/rizhi/" },
        { label: "下发设备指令", path: "/equipment/internationalGPS/equi/downEqIns/" },
        { label: "下发配置指令", path: "/equipment/internationalGPS/equi/downCfgIns/" },
        { label: "OTA升级", path: "/equipment/internationalGPS/equi/ota/" },
      ],
      env: this.getEnv(),
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0
        
      },
    };
  },
  watch: {
    deviceId: {
      handler(newVal, oldVal) {
        if (newVal === '') {
          this.pagin.pageNum = 1;
          this.getList();
        }
      },
      deep: true,
    },
    imei: {
      handler(newVal, oldVal) {
        if (newVal === '') {
          this.pagin.pageNum = 1;
          this.getList();
        }
      },
      deep: true,
    },
  },
    async created() {
    if (this.$route.params.id) {
      this.deviceId = this.$route.params.id !== ':id' ? this.$route.params.id : '';
      this.tableHeight = document.documentElement.clientHeight - 200 + "px";
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.relevancePagin.pageNum = val;
    },
    getList() {
      //数据绑定
      let params = {
        deviceId: this.deviceId,
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        topicType: "C/LOGIN",
      };
      if (this.deviceId.trim() != "") {
        params.deviceId = this.deviceId;
      }
      if (this.imei.trim() != "") {
        params.imei = this.imei;
      }
      if (this.imsi.trim() != "") {
        params.imsi = this.imsi;
      }
      this.$http
        .post(`${this.env}/manage/carDeviceTopicUpload/list`, params)
        .then((results) => {
          console.log(results);
          const records = results["data"]["data"]["records"];
          // 解析 json_data 字段
          this.data = records.map(item => {
            let jsonData = {};
            try {
              jsonData = JSON.parse(item.json_data || '{}');
            } catch (e) {
              console.error('解析 json_data 失败:', e);
            }
            return {
              ...item,
              dayTime: jsonData.dayTime || '',
              protocolVer: jsonData.protocolVer || '',
              swVer: jsonData.swVer || '',
              hwVer: jsonData.hwVer || '',
              iccid: jsonData.iccid || '',
              imsi: jsonData.imsi || '',
              mac: jsonData.mac || '',
            };
          });
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.baitengfa.com";
      }
    },

  },
  components: { Pagination },
};
</script>
  
  <style scoped>
.tab {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
</style>